/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { getMutationApiEndpoint } from '../../Services/Api/EndpointService';

/**
 * Custom useBestFitMutation hook
 * @param apiEndpointKey
 * @param successCallback
 * @param errorCallback
 * @param config
 * @returns {UseMutationResult<TData, unknown, void, unknown>}
 */
export const useBestFitMutation = (
  apiEndpointKey,
  successCallback = undefined,
  errorCallback = undefined,
  config = { headers: { 'content-type': 'application/json' } },
) => useMutation((formData) => axios.post(
  getMutationApiEndpoint(apiEndpointKey),
  formData,
  config,
), {
  onSuccess: (data, variables) => {
    if (successCallback) {
      successCallback(data, variables);
    }
  },
  onError: (data, variables) => {
    if (errorCallback) {
      errorCallback(data, variables);
    }
  },
});
